/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';
import Switch from 'Components/UI/Switch';

export const ClientProfileOverride = fr.metaOverride()
  .nameOverride('isConsideringJobChange', { _component: () => Switch })
  .nameOverride('isEmployed', { _component: () => Switch });
